export default __webpack_public_path__ + "static/media/avatarA8.53b42851.png";